module.exports = __webpack_public_path__ + "img/champollion.0c79cdfd.jpeg";